// extracted by mini-css-extract-plugin
export default {"container":"style_container__tfWZ9","p":"style_p__vMdNM","icon":"style_icon__BJMYI"};